module.exports = __webpack_public_path__ + "images/mobile/stars/message-9ff40d8d5dbfe8117ee1a293e73bc512.png";